import React from "react"
import "../sass/animate.css"
import About from "./about"

export default About
